/** @jsxImportSource react */

import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import { useRouter } from "next/router";
import cn from "classnames";
import styles from "./styles.module.scss";
import HexForm from "@/assets/HexForm.svg";

export const Form = ({ className, form, successPageUrl, title = "Subscribe now" }) => {
  if (!form) return null;

  const locale = useRouter().asPath.startsWith("/us/") ? "/us/" : "/";

  return (
    <section className={cn(styles.Form, className)} data-component="Form">
      <HexForm />

      <div className={styles.heading} data-sourceflow-prop="title" dangerouslySetInnerHTML={{ __html: title }} />

      <div className={styles.formWrapper}>
        <SourceFlowForm formId={form} onSubmitDone={() => (window.location.href = `${locale}${successPageUrl}`)} />
      </div>
    </section>
  );
};

export default Form;
